import type { RouteObject } from "react-router-dom";
import Layout from "../components/layout/Layout";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Rankings from "../pages/rankings/page";
import Category from "../pages/category/page";
import ComicDetail from "../pages/comic/page";
import About from "../pages/about/page";
import Faq from "../pages/faq/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "rankings", element: <Rankings /> },
      { path: "category/:slug", element: <Category /> },
      { path: "comic/:id", element: <ComicDetail /> },
      { path: "about", element: <About /> },
      { path: "faq", element: <Faq /> },
      { path: "contact", element: <Contact /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;